class modalDetailsCtrl {
    constructor($scope, $uibModalInstance, httpRequest, items2, globalFn) {
        $scope.dictionary = items2.dictionary
        // 分页
        $scope.totalItems = 1;
        $scope.hg_totalItems = 1;
        // 分页参数
        $scope.invoiceCheckType = 1;
        $scope.tabChange = function tabChange(type) {
            $scope.invoiceCheckType = type;
        };
        $scope.pageRequestDTO = {
            pageNum: 1,
            pageSize: 10,
            param: items2,
        };
        $scope.hg_pageRequestDTO = {
            pageNum: 1,
            pageSize: 10,
            param: items2,
        };
        function fixNumber(v){
            if(v===null||v===''||v===undefined)return ''
            return v.toFixed(2)
        }
        function getInvoiceDetail(){
                //发票明细
            httpRequest
            .post_ivatAuthStatisticsInvoiceDetail($scope.pageRequestDTO)
            .then(res => {
                if (res.data.success) {
                    $scope.totalItems = res.data.value.total;
                    $scope.pageRequestDTO.pageNum = ++res.data.value.prePage;
                    $scope.pageRequestDTO.pageSize = res.data.value.pageSize;
                    let result=res.data.value.list;
                    result.forEach(item=>{
                        item.totalAmt=fixNumber(item.totalAmt)
                        item.totalTaxamt=fixNumber(item.totalTaxamt)
                        item.effectiveTaxamt=fixNumber(item.effectiveTaxamt)
                    })
                    $scope.modalDetailsList =result
                }
            });
        }
        function getCustomsPayment(){
            //海关缴款明细
            httpRequest.post_getCustomsPayment($scope.hg_pageRequestDTO).then(res => {
                if (res.data.success) {
                    $scope.hg_totalItems = res.data.value.total;
                    $scope.hg_pageRequestDTO.pageNum = ++res.data.value.prePage;
                    $scope.hg_pageRequestDTO.pageSize = res.data.value.pageSize;
                    let result=res.data.value.list;
                    result.forEach(item=>{
                        item.totalTaxamt=fixNumber(item.totalTaxamt)
                    })
                    $scope.hg_modalDetailsList =result
                }
            });
        }
        getCustomsPayment()
        getInvoiceDetail()
        const initModalDetails = () => {
            if ($scope.invoiceCheckType == 1) {
                //发票明细
                getInvoiceDetail()
            } else {
                //海关缴款明细
                getCustomsPayment()
            }
        };
        initModalDetails();
        $scope.pageChanged = () => {
            initModalDetails();
        };
        $scope.cancel = () => {
            // $uibModalInstance.dismiss();
            $uibModalInstance.close();
        };
        $scope.exportDetails = () => {
            let params={accessToken:localStorage.id_token,creditCode:items2.creditCodeList[0],periodCode:items2.periodCode}
            if($scope.invoiceCheckType == 1){
                httpRequest.get_exportInvoiceDetail(params);
            }else{
                httpRequest.get_exportExportCustomsPayment(params);
            }
        };
    }
}

modalDetailsCtrl.$inject = ['$scope', '$uibModalInstance', 'httpRequest', 'items2','globalFn'];
export default modalDetailsCtrl;



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/identificationSummarize/modalDetailsCtrl.js